import type React from "react";

import { useTodoVM } from "../Root.js";
import { LiveValue } from "./LiveValue.tsx";

const pluralize = (count: number, singular: string, plural: string) => (count === 1 ? singular : plural);

export const Footer: React.FC = () => {
  const vm = useTodoVM();
  const filter = vm.footer.currentFilter$;
  const incompleteCount = vm.footer.incompleteCount$;

  return (
    <footer data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:14:13" data-name="footer" className="footer">
      <span data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:15:13" data-name="span" className="todo-count">
        <LiveValue query={incompleteCount}>
          {(incompleteCount) => `${incompleteCount} ${pluralize(incompleteCount, "item", "items")} left`}
        </LiveValue>
      </span>
      <ul data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:20:11" data-name="ul" className="filters">
        <LiveValue query={filter}>
          {(filter) => (
            <>
              <li data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:24:19" data-name="li">
                <a href="#/" data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:25:30" data-name="a" className={filter === "all" ? "selected" : ""} onClick={vm.footer.showAll}>
                  All
                </a>
              </li>
              <li data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:29:19" data-name="li">
                <a href="#/" data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:30:30" data-name="a" className={filter === "active" ? "selected" : ""} onClick={vm.footer.showActive}>
                  Active
                </a>
              </li>
              <li data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:34:19" data-name="li">
                <a href="#/" data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:35:30" data-name="a" className={filter === "completed" ? "selected" : ""} onClick={vm.footer.showCompleted}>
                  Completed
                </a>
              </li>
            </>
          )}
        </LiveValue>
      </ul>
      <button type="button" data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Footer.tsx:43:29" data-name="button" className="clear-completed" onClick={vm.footer.clearCompleted}>
        Clear completed
      </button>
    </footer>
  );
};
